module.exports = new Promise(function(resolve) {
  function getAppConfig (apps) {
    var appConfig = apps['welcome'];
    try {
      var predefinedVersion = JSON.parse(localStorage.getItem('vm/__appVersion'));
      if (predefinedVersion) {
        appConfig.version = predefinedVersion;
      }
    } catch (e) {
      console.log(e);
    }
    return appConfig;
  }
  function loadApp(appConfig) {
    var remoteUrl = window.location.origin + '/apps/welcome_' + appConfig.version + '/welcome.js';
    var script = document.createElement('script');
    script.src = remoteUrl;
    script.onload = function() {
      var proxy = {
        get: function(request) { return window['welcome'].get(request); },
        init: function(arg) {
          try {
            return window['welcome'].init(arg);
          } catch(e) {
            console.log('remote container already initialized');
          }
        }
      }
      resolve(proxy);
    }
    document.head.appendChild(script);
  }
  function fetchJSON(path) {
    return new Promise(function(res) {
      var request = new XMLHttpRequest();
      request.addEventListener('load', function() {
        res(JSON.parse(this.responseText));
      });
      request.open('GET', path);
      request.send();
    });
  }
  window.__vmosAppsRequest__ = window.__vmosAppsRequest__ || fetchJSON(window.location.origin + '/apps.json');
  window.__vmosConfigRequest__ = window.__vmosConfigRequest__ || fetchJSON(window.location.origin + '/config.json');
  window.__vmosAppsRequest__.then(getAppConfig).then(loadApp);
  window.__vmosConfigRequest__.then(function(config) {
    window.__vmosConfig__ = config;
  });
  window.__vmosAppsRequest__.then(function(config) {
    window.__vmosVersion__ = config.kiosk && config.kiosk.version;
  });
})
;